import {
    createSlice,
} from '@reduxjs/toolkit';

export const SLICE_NAME = 'betHistory';

const initialState = {
    currentTab: 'openBets',
    openBets: {
        currentPage: 1,
    },
    settledBets: {
        currentPage: 1,
    },
    'otherAccounts:openBets': {
        currentPage: 1,
    },
    'otherAccounts:settledBets': {
        currentPage: 1,
    },
    betsCashout: {},
    betsCashoutToken: null,
};

const betHistory = createSlice({
    name: SLICE_NAME,
    initialState,
    reducers: {
        updateSettledBetsHistory: (state, { payload }) => {
            const { data, isOtherAccount } = payload;
            const key = isOtherAccount ? 'otherAccounts:settledBets' : 'settledBets';

            state[key] = {
                currentPage: state[key].currentPage,
                ...data,
            };
        },
        updateOpenBetsHistory: (state, { payload }) => {
            const { data, isOtherAccount } = payload;
            const key = isOtherAccount ? 'otherAccounts:openBets' : 'openBets';

            state[key] = {
                currentPage: state[key].currentPage,
                ...data,
            };
        },
        setOpenBetsTab: (state) => {
            state.currentTab = 'openBets';
        },
        setSettledBetsTab: (state) => {
            state.currentTab = 'settledBets';
        },
        setOlderBetsTab: (state) => {
            state.currentTab = 'olderBets';
        },
        setOtherOpenBetsTab: (state) => {
            state.currentTab = 'otherAccounts:openBets';
        },
        setOtherSettledBetsTab: (state) => {
            state.currentTab = 'otherAccounts:settledBets';
        },
        updateAllBetsCashout: (state, { payload }) => {
            Object.keys(state.betsCashout)?.forEach(key => {
                const betCashout = state.betsCashout[Number(key)] || {};

                state.betsCashout[key] = {
                    ...betCashout,
                    ...payload,
                };
            });
        },
        updateBetCashout: (state, { payload: { bet_id, ...data } }) => {
            if (bet_id !== undefined && bet_id !== 'undefined') {
                const betCashout = state.betsCashout[Number(bet_id)] || {};

                state.betsCashout[Number(bet_id)] = {
                    ...betCashout,
                    ...data,
                };
            }
        },
        setBetsCashoutToken: (state, { payload }) => {
            state.betsCashoutToken = payload;
        },
        betsCashoutCleanUp: (state) => {
            state.betsCashout = initialState.betsCashout;
        },
        openBetsCleanUp: (state) => {
            state.openBets = initialState.openBets;
        },
        settledBetsCleanUp: (state) => {
            state.settledBets = initialState.settledBets;
        },
        otherOpenBetsCleanUp: (state) => {
            state['otherAccounts:openBets'] = initialState['otherAccounts:openBets'];
        },
        otherSettledBetsCleanUp: (state) => {
            state['otherAccounts:settledBets'] = initialState['otherAccounts:settledBets'];
        },
        updateBetsPage: (state, { payload: { betType, page } }) => {
            state[betType] = {
                ...state[betType],
                currentPage: page,
            };
        },
    },
});

export const {
    updateSettledBetsHistory,
    updateOpenBetsHistory,
    setOpenBetsTab,
    setSettledBetsTab,
    setOlderBetsTab,
    setOtherOpenBetsTab,
    setOtherSettledBetsTab,
    updateBetsPage,
    updateAllBetsCashout,
    updateBetCashout,
    setBetsCashoutToken,
    betsCashoutCleanUp,
    openBetsCleanUp,
    settledBetsCleanUp,
    otherOpenBetsCleanUp,
    otherSettledBetsCleanUp,
} = betHistory.actions;

export default betHistory.reducer;
